export default {
    heading: theme => ({
        margin: 0,
        padding: `${theme.layout.baseline}px 0`,
        color: theme.colors.grey,
        borderBottom: `1px solid ${theme.colors.greyLight}`,
        [theme.helpers.mq('m')]: {
            fontSize: theme.font.scale.large
        }
    }),
    content: theme => ({
        padding: `${theme.layout.baseline * 1.5}px 0`
    }),
    actionButtons: theme => ({
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'baseline',
        marginTop: theme.layout.baseline,
        flexWrap: 'wrap'
    }),
    actionButton: theme => ({
        flexGrow: 1,
        marginLeft: theme.layout.baseline,
        '&:first-of-type': {
            marginLeft: 0
        },
        [theme.helpers.mq('s')]: {
            flexGrow: 'inherit'
        }
    })
};
